import { createSelector, createStructuredSelector } from 'reselect';
import { initialState } from './reducer';
import { RootState } from '../../interface';
import { NameSpace } from '../../enum';

/**
 * Selects the container's state from RootState based on the given namespace
 * @param {RootState} state - rootstate of the app
 * @returns {AppState} - the App container's state
 */
export const selectState = (state: RootState) => state[NameSpace.APP] || initialState;

export const selectLoading = createSelector(selectState, state => state.isLoading);
export const selectError = createSelector(selectState, state => state.error);
export const selectProduct = createSelector(selectState, state => state.product);

/**
 * Create a structured selector. (Map our selectors into specific keys in an object)
 * Used to connect the state to the container
 */
export const mapStateToProps = createStructuredSelector({
    loading: selectLoading,
    error: selectError,
    product: selectProduct,
});
